import { Close } from "@mui/icons-material";
import { useEffect, useMemo, useRef } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { ToolbarButtonEntry, toolbarsActions, useDispatchToolbars } from "contexts/toolbars";
import { CloseIconButton } from "features/quickAccessMenu/procore/closeIconButton";
import { Picker, renderActions } from "features/render";

import { Toolbar } from "../Toolbar";

interface ToolsPickerToolbarProps {
    picker: Picker;
    id?: string;
}

/**
 * Toolbar with close button that appears when measurement and section tools are active
 */
export function ToolsPickerToolbar({ picker, id = "tools-picker-toolbar" }: ToolsPickerToolbarProps) {
    const dispatch = useAppDispatch();
    const toolbarDispatch = useDispatchToolbars();

    const pickerRef = useRef(picker);
    useEffect(() => {
        pickerRef.current = picker;
    }, [picker]);

    const toolsPickers = [
        Picker.OutlineLaser,
        Picker.Coordinates,
        Picker.PointLine,
        Picker.Dimension,
        Picker.SectionPlane,
    ];
    const shouldShowToolbar = toolsPickers.includes(picker);
    const buttons: ToolbarButtonEntry[] = useMemo(
        () => [
            {
                config: {
                    id: "close-picker",
                    icon: <Close fontSize="large" />,
                    onClick: () => dispatch(renderActions.stopPicker(pickerRef.current)),
                    title: "Close",
                    component: CloseIconButton,
                },
                state: {
                    active: false,
                    disabled: false,
                    visible: shouldShowToolbar,
                },
            },
        ],
        [dispatch, shouldShowToolbar],
    );

    useEffect(() => {
        toolbarDispatch(
            toolbarsActions.addToolbar({
                id,
                buttons,
            }),
        );

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, buttons]);

    return <Toolbar id={id} />;
}
